'use strict';

let OrderServiceModule = require('./OrderService');

module.exports = function(param) {
    // Adding support to use individual module standalone
    if(typeof param !== "object"){
        param = {};
    }
    // providing option to inject Custom EventBus
    if(param && typeof param._EventBus !== "object"){
        param._EventBus = require('../core/EventBus');
    }
    return new OrderServiceModule(param);
};


// WEBPACK FOOTER //
// ./src/order/index.js